import React from 'react';

const CmsItem = ({ cmsData }) => {
    console.log(cmsData);
    return (
        <div className='event-cms__item'>
            {cmsData.map((item, index) => (
                <div key={index}>
                    <h2>{item.Title}</h2>

                    {item.cmsContent.map((cms, cmsIndex) => {
                        if (cms.type === 'paragraph') {
                            return (
                                <p key={cmsIndex}>
                                    {cms.children.map((child, childIndex) => (
                                        <span key={childIndex}>{child.text}</span>
                                    ))}
                                </p>
                            );
                        }

                        if (cms.type === 'list' && cms.format === 'unordered') {
                            return (
                                <ul key={cmsIndex}>
                                    {cms.children.map((listItem, listItemIndex) => (
                                        <li key={listItemIndex}>
                                            {listItem.children.map((child, childIndex) => (
                                                <span key={childIndex}>{child.text}</span>
                                            ))}
                                        </li>
                                    ))}
                                </ul>
                            );
                        }

                        return null; 
                    })}
                </div>
            ))}
        </div>
    );
};

export default CmsItem;
